$(document).ready(function ()
{
  
// Bei Hover auf Account Element
    $('#myiww').hoverIntent({
        sensitivity: 150, // number = sensitivity threshold (must be 1 or higher)
        interval: 150,  // number = milliseconds for onMouseOver polling interval
        timeout: 300,   // number = milliseconds delay before onMouseOut

        // Hover Over
        over: function ()
        {
            // Finde Subnavigation Element
            $(this).find('#submenu')

                // Display auf block setzen und einfaden 200ms
                .fadeIn(200).css("display", "block");
        },
        // Hover Out
        out: function ()
        {
            // Finde Subnavigation Element
            $(this).find('#submenu')
                // Element ausfaden
                   .fadeOut(200);
        }
    });
});